const productGrid = document.querySelector("#product-grid");

function setColumnCount(device, columns) {
  if (!productGrid) return;
  
  const classPrefix = device === 'desktop' ? 'grid--' : 'grid--';
  const classSuffix = device === 'desktop' ? '-col-desktop' : '-col-tablet-down';
  
  const possibleColumns = device === 'desktop' ? [3, 4] : [1, 2];
  
  possibleColumns.forEach(col => {
    if (col === columns) {
      productGrid.classList.add(`${classPrefix}${col}${classSuffix}`);
    } else {
      productGrid.classList.remove(`${classPrefix}${col}${classSuffix}`);
    }
  });
}
